import { z } from 'zod';
/**
 * Section 5 conventions: success is `{ data: ... }`, failure is
 * `{ error: { code, message } }`, and lists page with a cursor.
 */
/** `code` is a stable machine-readable string; `message` is for people. */
export const ApiErrorBody = z.object({
    error: z.object({
        code: z.string().min(1).max(64),
        message: z.string().min(1).max(1000),
    }),
});
export const apiResult = (data) => z.object({ data });
export const apiPage = (item) => z.object({
    data: z.array(item),
    next_cursor: z.string().nullable(),
});
//# sourceMappingURL=api.js.map